<template>
   <div class="row">
      <table v-for="itr_table in [0, 1]" class="table table-sm table-hover col-md-5 mx-auto" v-bind:key="itr_table">
         <thead>
            <tr>
               <th> <span class="ml-6">Markt</span> </th>
	            <th>Category</th>
	            <th>Sales</th>
	            <th>Rank</th>
               <th></th>
               <th style="width: 5%">Aktiv</th>
            </tr>
         </thead>
         <tbody>
            <tr v-for="(market, index) in partitionedMarkets[itr_table]" v-bind:key="index">
               <td id="table-row-url-link">
                  <a @click="openInNewTab(buildLink(market.identifier))" onmouseover style="cursor: pointer;">
                     <b class="ml-2"> <font color="#3399ff">{{market.name}}</font> </b>
                  </a>
               </td>
	            <td id="table-row-sales-count">
		            <span v-if="market.marketProductCategory">{{ categoryOptions[market.marketProductCategory] }}</span>
		            <span v-else>—</span>
	            </td>
               <td id="table-row-sales-count">
                   <span v-if="market.salesCount">{{ market.salesCount }}</span>
                   <span v-else>—</span>
               </td>
	            <td id="table-row-sales-rank">
		            <span v-if="market.salesRank">{{market.salesRank}}</span>
		            <span v-else>—</span>
	            </td>
               <td>
                  <a @click="openInNewTab(buildLink(market.identifier))" onmouseover style="cursor: pointer;">
                     <b v-if="!market.synchrotronMarketId">?</b>
                     <img v-else
                        :src="`/images/marketicons/${market.synchrotronMarketId}.gif`"
                        border="0" width="16" height="16"
                     />
                  </a>
               </td>
               <td>
                  <span v-if="market.blockerComputed === null  || market.blockerComputed === undefined" class="icon icon-checkmark text-success" />
                  <span v-else-if="(market.blockerComputed.blackOrWhite)" class="icon icon-cross text-danger" />
                  <span v-else class="icon icon-checkmark text-success" />
               </td>
            </tr>
         </tbody>
      </table>
   </div>
</template>
<script>
export default {
   props: [ "passedMaterial", "blockerComputedTableData", "productCategories" ],
   data() {
      return {
         blockerComputed: null,
         marketAccounts: [],
         markets: null,
         salesIndexes: null,
         marketLinks: { //TODO modify market??? table? This might be viable in mds.
            "AMZ-AE": "https://www.amazon.ae/",
            "AMZ-AU": "https://www.amazon.com.au/",
            "AMZ-BR": "https://www.amazon.com.br/",
            "AMZ-CA": "https://www.amazon.ca/",
            "AMZ-DE": "https://www.amazon.de/",
            "AMZ-ES": "https://www.amazon.es/",
            "AMZ-FR": "https://www.amazon.fr/",
            "AMZ-IE": "https://www.amazon.ie/",
            "AMZ-IT": "https://www.amazon.it/",
            "AMZ-JP": "https://www.amazon.co.jp/",
            "AMZ-MX": "https://www.amazon.com.mx/",
            "AMZ-NL": "https://www.amazon.nl/",
            "AMZ-BE": "https://www.amazon.com.be/",
            "AMZ-PL": "https://www.amazon.pl/",
            "AMZ-SE": "https://www.amazon.se/",
            "AMZ-SG": "https://www.amazon.sg/",
            "AMZ-TR": "https://www.amazon.com.tr/",
            "AMZ-UK": "https://www.amazon.co.uk/",
            "AMZ-US": "https://www.amazon.com/",
            "BOL-NL": "https://www.bol.com/nl/s/?searchtext=",
            "CDC-FR": "https://www.cdiscount.com/search/10/", //ean.html
            "EPR-IT": "https://www.eprice.it/",
            "FNC-BE": "https://www.fr.fnac.be/SearchResult/ResultList.aspx?Search=", // ean
            "FNC-ES": "https://www.fnac.es/SearchResult/ResultList.aspx?Search=", // ean
            "FNC-FR": "https://www.fnac.com/SearchResult/ResultList.aspx?Search=", // ean
            "FNC-PT": "https://www.fnac.pt/SearchResult/ResultList.aspx?Search=", // ean
            "RAK-FR": "https://fr.shopping.rakuten.com/search/", // ean
            "RDC-FR": "https://www.rueducommerce.fr/",
            "REL-DE": "https://www.kaufland.de/s/?search_value=", //ean
            "WRT-ES": "https://www.worten.es/search?query=", //ean
            "WRT-PT": "https://www.worten.pt/search?query=", //ean
            "ALG-PL": "https://allegro.pl/listing?string=", //ean
            "WAL-US":"https://www.walmart.com/search?q=", // ean
            "KFL-SK": "https://www.kaufland.sk/s/?search_value=", //ean
            "KFL-CZ": "https://www.kaufland.cz/s/?search_value=", //ean
            "KFL-AT": "https://www.kaufland.at/s/?search_value=", //ean
				 },
	      categoryOptions : [],
      };
   },
   computed: {
      partitionedMarkets: function() {
         if(!this.markets) return [[],[]];
         return [
            this.markets.filter( market => (market.id + 1) % 2 == 0 ).sort( (a,b) => a.synchrotronMarketId - b.synchrotronMarketId ),
            this.markets.filter( market => (market.id + 1) % 2 != 0 ).sort( (a,b) => a.synchrotronMarketId - b.synchrotronMarketId )
         ];
      }
   },
	watch: {
		blockerComputedTableData: {
			handler(newVal) {
				if (!newVal || newVal === null || newVal === undefined) {
					console.warn("blockerComputedTableData not ready yet");
					return;
				}
				this.initBlockerComputedTable()
			}
		}
	},
   methods: {
      openInNewTab(url) {
         const win = window.open(url, "_blank");
         win.focus();
      },
      buildLink(marketIdentifier) {
         switch(marketIdentifier.substring(0, 3))
         {
            case "BOL": return this.marketLinks[marketIdentifier] + this.passedMaterial.ean;
            case "AMZ": return this.marketLinks[marketIdentifier] + 'dp/' + this.passedMaterial.asin;
            case "FNC":
	          case "WRT":
					  case "RAK":
					  case "KFL":
	          case "REL": return this.marketLinks[marketIdentifier] + this.passedMaterial.ean;
            case "CDC": return this.marketLinks[marketIdentifier] + this.passedMaterial.ean + ".html";
					  case "ALG": return this.marketLinks[marketIdentifier] + this.passedMaterial.ean;
					  case "WAL": return this.marketLinks[marketIdentifier] + this.passedMaterial.ean;
            default:    return this.marketLinks[marketIdentifier] + this.passedMaterial.asin;
         }
      },
      initBlockerComputedTable() {
	        this.markets = this.blockerComputedTableData.mdsMarkets.filter( market => {
	           if(this.blockerComputedTableData.marketAccounts.find(
	              marketAccount => market.identifier == marketAccount.mdsMarketIdentifier )
	           ) return true;
	           return false;
	        }).map( market => {
	           // filter markets by existing market accounts
	           // get DB Synchtrotron.market.id for the market gif names
	           const maybeSynchrotronMarket = this.blockerComputedTableData.markets.find( synchrotronMarket => synchrotronMarket.mdsMarketIdentifier === market.identifier );

	           if(maybeSynchrotronMarket) {
	              market.synchrotronMarketId = maybeSynchrotronMarket.id;
	           } else {
	              market.synchrotronMarketId = null;
	           }

	           const sales = this.blockerComputedTableData.productSales.filter( x => x.marketId === market.id)
	           market.salesCount = 0;

	           for(const sale of sales) market.salesCount += sale.quantity;

	           let blockerComputed = this.blockerComputedTableData.blockerComputed.find( o => {
	              return o.market.identifier === market.identifier
	           });

	           market.blockerComputed = (blockerComputed) ? blockerComputed : null;

		        for(const marketProduct of this.passedMaterial.product.marketProducts){
			        if(marketProduct.marketIdentifier === market.identifier){
								market.salesRank = marketProduct.salesRank;
								market.marketProductCategory = marketProduct.category;
			        }
		        }

	           return market;
	        });

	        // map marketAccount salesindexes onto Market...this seems like we might run into some collisions. I'm not sure if
	        // we can do this with the way we are mapping data in the moment.
	        for(const salesIndex of this.passedMaterial.salesindexes)
	        {
	           if(!salesIndex || !salesIndex.marketaccount || !salesIndex.marketaccount.market
	           || !salesIndex.marketaccount.market.mdsMarketIdentifier) continue;

	           // it is important to note that the marketAccount.market is on the Synchrotron DB server side,
	           // which means we need to go over mdsMarketIdentifier. This also means we might run into collisions.
	           // is it just one account per market?
	           let maybe = this.markets.find( market => market.identifier === salesIndex.marketaccount.market.mdsMarketIdentifier );
	           maybe.salesIndex = salesIndex; //.salesIndexes.push(salesIndex);
	        }

      }
   },
   created() {
		Object.values(this.productCategories).forEach(category => {
		 	this.categoryOptions[category.categoryId] = category.uiName;
		});
	 }
};
</script>
